import Tabs from "#common/tabs/Tabs"
import { Box } from "@mui/material"
import { ChangeTitle } from "Components/menu/funciones"
import { useState } from "react"
import Planning from "./Planning"
import AnnualPlanCreate from "./AnnualPlanCreate"

const Index = () => {
	ChangeTitle("Plan de Capacitación")
	const [selectTab, setSelectTab] = useState(0)
	const handleChange = (event, newValue) => {
		setSelectTab(event)
	}
	const tabs = [
		{
			title: "planeación",
			component: <Planning />,
			show: true,
		},

		{
			title: "Plan Anual",
			component: <AnnualPlanCreate />,
			show: true,
		},
	]
	return (
		<Box>
			<Tabs
				tabs={tabs}
				onChange={handleChange}
				value={selectTab}
				setValue={setSelectTab}
			/>
		</Box>
	)
}
export default Index
